import { isRegExp } from 'lodash-es';

export const shouldIgnoreCapturedError = (
  error: Error,
  ignoredErrors: (RegExp | string)[],
): boolean => {
  return ignoredErrors.some((ignoredError) => {
    const errorRegex = isRegExp(ignoredError) ? ignoredError : new RegExp(ignoredError);

    return errorRegex.test(error.message) || errorRegex.test(error.name);
  });
};
